<template>
  <div>
    <p>{{ $t('text.unauthorized')}}</p>
    <v-btn color="primary ma-1" href="/">{{ $t('button.backToApp')}}</v-btn>
    <v-btn color="primary" href="settings/feedback">{{ $t('button.report')}}</v-btn>
  </div>
</template>

<script>
export default {
  name: "neoparent-unauthorized"
}
</script>

<style scoped>

</style>
